import { Form } from 'antd'
import styled from 'styled-components'

export const FormItem = styled(Form.Item)`
  margin-top: 0px;
  margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '0px'} !important;
  width: ${props =>
    props.width ? props.width : '100%'};
  .ant-form-item-explain-error {
    padding-left: ${props => (props.padding ? '15%' : '0')};
  }
  .ant-form-item-control-input {
    min-height: 0px;
  }
`
